import { render, staticRenderFns } from "./RegisterFranchise.vue?vue&type=template&id=08dfef60"
import script from "./RegisterFranchise.vue?vue&type=script&lang=js"
export * from "./RegisterFranchise.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports